import { FocusRing } from '../../../utils/FocusRing';
import { CardsListDesktop } from './view';
import s from './styles.scss';

const focusRing = new FocusRing(s.focused);
focusRing.init();

export { CardsListDesktop as CardsListDesktopController };
